import {ColonicalInfoData} from "./ColonicalInfoData";
import {useEffect, useState} from "react";

/**
 * 아카이브 > 연도별 조선제학교 일람 특징 정보
 * @param year
 * @param backToList 뒤로가기 함수
 * @returns {JSX.Element}
 */
const ColonicalInfoModal = ({year, backToList}) => {
    // 연도별 일람 특징 정보
    const [data, setData] = useState(null);

    // 데이터 가져오기 및 세팅
    useEffect(() => {
        const loadData = async () => {
            try {
                const result = await fetchColonicalInfoData(year);
                setData(result);
            } catch (error) {
                console.error('데이터를 가져오는 중 오류가 발생했습니다:', error);
                setData(null);
            }
        };

        loadData();
    }, [year]);

    // 데이터 가져오는 함수
    const fetchColonicalInfoData = async (selectedYear) => {
        try {

            return await ColonicalInfoData[0][selectedYear];
        } catch (error) {
            throw new Error('데이터를 가져오는 중 오류가 발생했습니다: ' + error.message);
        }
    };

    return (
        <>

            {data ? (
                <>
                    <div className="popup-header">
                        <b className="popup-title">{data.year}년도판</b>
                        <button
                            type="button"
                            className="popup-close"
                            onClick={backToList}
                        >
                            닫기
                        </button>
                    </div>
                    <div className="popup-cont">
                        <div className="popup-text">
                            <ul className="year-text">
                                <li>{data.content}</li>
                            </ul>
                        </div>
                    </div>

                </>
            ) : (
                <>
                    <div className="popup-header">
                        <b className="popup-title">알림</b>
                        <button
                            type="button"
                            className="popup-close"
                            onClick={backToList}
                        >
                            닫기
                        </button>
                    </div>
                    <div className="popup-cont">
                        <div className="popup-text">
                            <ul className="year-text">
                                <li>데이터가 없습니다</li>
                            </ul>
                        </div>
                    </div>
                </>
            )
            }
        </>
    );
};

export default ColonicalInfoModal;